import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { FiEdit2, FiEye, FiMail, FiMapPin, FiPhone, FiPlayCircle, FiTrash2 } from "react-icons/fi";
import { formatMobileDisplayOrFallback } from "../restaurant/formatDisplay";

const phoneDigits = (value) => String(value || "").replace(/\D/g, "");

/** wa.me needs the country code; bare 10-digit numbers are treated as Indian mobiles. */
const whatsappNumber = (value) => {
  const digits = phoneDigits(value).replace(/^0+/, "");
  if (!digits) return "";
  return digits.length === 10 ? `91${digits}` : digits;
};

export function AdminRowActions({ name, phone, email, mapUrl, onView, onEdit, onDeactivate, onContinue }) {
  const waNumber = whatsappNumber(phone);
  return (
    <div className="eats-admin-row-actions">
      {mapUrl ? (
        <a
          href={mapUrl}
          target="_blank"
          rel="noreferrer"
          className="eats-admin-icon-btn eats-admin-icon-btn--map"
          title="Open in Google Maps"
          aria-label={`Open ${name} in Google Maps`}
        >
          <FiMapPin aria-hidden="true" />
        </a>
      ) : null}
      {phone ? (
        <a
          href={`tel:${phoneDigits(phone)}`}
          className="eats-admin-icon-btn"
          title={`Call ${formatMobileDisplayOrFallback(phone, phone)}`}
          aria-label={`Call ${name}`}
        >
          <FiPhone aria-hidden="true" />
        </a>
      ) : null}
      {waNumber ? (
        <a
          href={`https://wa.me/${waNumber}`}
          target="_blank"
          rel="noreferrer"
          className="eats-admin-icon-btn eats-admin-icon-btn--whatsapp"
          title="WhatsApp"
          aria-label={`WhatsApp ${name}`}
        >
          <FaWhatsapp aria-hidden="true" />
        </a>
      ) : null}
      {email ? (
        <a
          href={`mailto:${email}`}
          className="eats-admin-icon-btn"
          title={`Email ${email}`}
          aria-label={`Email ${name}`}
        >
          <FiMail aria-hidden="true" />
        </a>
      ) : null}
      {(phone || email) && (onContinue || onView || onEdit || onDeactivate) ? (
        <span className="eats-admin-row-actions__sep" aria-hidden="true" />
      ) : null}
      {onContinue ? (
        <button
          type="button"
          className="eats-admin-icon-btn"
          onClick={onContinue}
          title="Continue create"
          aria-label={`Continue creating ${name}`}
        >
          <FiPlayCircle aria-hidden="true" />
        </button>
      ) : null}
      {onView ? (
        <button
          type="button"
          className="eats-admin-icon-btn eats-admin-icon-btn--view"
          onClick={onView}
          title="View"
          aria-label={`View ${name}`}
        >
          <FiEye aria-hidden="true" />
        </button>
      ) : null}
      {onEdit ? (
        <button
          type="button"
          className="eats-admin-icon-btn eats-admin-icon-btn--edit"
          onClick={onEdit}
          title="Edit"
          aria-label={`Edit ${name}`}
        >
          <FiEdit2 aria-hidden="true" />
        </button>
      ) : null}
      {onDeactivate ? (
        <button
          type="button"
          className="eats-admin-icon-btn eats-admin-icon-btn--danger"
          onClick={onDeactivate}
          title="Deactivate"
          aria-label={`Deactivate ${name}`}
        >
          <FiTrash2 aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}

/** Row click handler that ignores clicks on links, buttons and form controls inside the row. */
export function rowClickHandler(open) {
  if (!open) return undefined;
  return (event) => {
    if (event.target.closest("a, button, input, select, textarea, label")) return;
    open();
  };
}

export function AdminNameCell({ name, id, code, status, to }) {
  const normalized = String(status || "").toUpperCase();
  const tone = normalized === "ACTIVE" ? "active" : normalized === "INACTIVE" ? "inactive" : "default";
  const idLabel = `${code ? String(code).trim().toUpperCase() : ""}#${id}`;
  return (
    <span className="eats-admin-name-cell">
      {to ? (
        <Link to={to} className="eats-admin-link">
          {name}
        </Link>
      ) : (
        name
      )}
      {id ? (
        <span
          className={`eats-admin-row-id eats-admin-row-id--${tone}`}
          title={status ? `${idLabel} · ${status}` : undefined}
          aria-label={status ? `${code ? `Code ${code}, ` : ""}ID ${id}, ${status}` : undefined}
        >
          {idLabel}
        </span>
      ) : null}
    </span>
  );
}
